import { Translation } from "./translation";

export const TRANSLATIONS: { [key: string]: Translation } = {
    integrations: { da: 'Integrationer', en: 'Integrations', no: 'Integrasjoner' },
    activeIntegrations: { da: 'Aktive Integrationer', en: 'Active Integrations', no: 'Aktive integrasjoner' },
    keatechIntegrationDescription: { da: 'Integrering med Keatech', en: 'Keatech Integration', no: 'Integrasjon med Keatech' },
    xenaIntegrationDescription: { da: 'Integrering med Xena', en: 'Xena Integration', no: 'Integrasjon med Xena' },
    test: { da: 'test_da', en: 'test_en', no: 'test_no' },
};
